<template>
  <div class="zujian">
      <div class="map" >
        <div id="map"></div>
        <div class="detail" v-if="isDetail">
           <el-tabs v-model="activeName" >
              <el-tab-pane label="行驶信息" name="gps" v-if="vhoFlag">
                <div class="box1">
                   <div class="item"><span class="name">车牌号：</span><span>{{vehGps.plain}}</span></div>
                   <div class="item"><span  class="name">行驶状态：</span><span>{{vehGps.status}}</span></div>
                   <div class="item"><span  class="name">当前速度：</span><span>{{vehGps.speed}}KM/H</span></div>
                   <div class="item"><span  class="name">当前方向：</span><span> {{[ "北", "东北", "东", "东南", "南", "西南", "西", "西北" ][vehGps.fx-1]}}</span></div>
                   <div class="item"><span  class="name">总计里程：</span><span>{{vehGps.mileage ? vehGps.mileage : 0}}KM</span></div>
                   <div class="item"><span  class="name">设备ID：</span><span>{{vehGps.terminal_code}}</span></div>
                   <div class="item"><span  class="name">SIM卡号：</span><span>{{vehGps.sim}}</span></div>
                   <div class="item"><span  class="name">经度：</span><span>{{vehGps.longitude}}</span></div>
                   <div class="item"><span  class="name">纬度：</span><span>{{vehGps.latitude}}</span></div>
                   <div class="item item1"><span  class="name">上报时间：</span><span>{{vehGps.gps_time}}</span></div>
                  <div class="item item1"><span  class="name">当前位置：</span><span>{{vehGps.address}}</span></div>
               </div>
             </el-tab-pane>
             <!-- <el-tab-pane label="司机" name="siji"  v-if="(mapData.type == 1||mapData.type == 3) && siJiFlag">
                <div class="box1">
                   <div class="item"><span class="name">司机姓名：</span><span>{{mapData.dirverName}}</span></div>
                   <div class="item item1"><span  class="name">当前位置：</span><span>{{siJiAddressGrid}}</span></div>
                   <div class="item"><span  class="name">经度：</span><span>{{driverData.longitude}}</span></div>
                   <div class="item"><span  class="name">纬度：</span><span>{{driverData.latitude}}</span></div>
                </div>
              </el-tab-pane> -->
          </el-tabs>
          <div class="close" @click="closeFn"><i class="el-icon-close"></i></div>
        </div>
        <div class="tuli">
          <div class="box2">
            <div class="item"><img src="../../../../assets/vehMonitor/xingshi.png"><span>行驶</span></div>
            <div  class="item"><img src="../../../../assets/vehMonitor/tingche.png"><span>停车</span></div>
            <!-- <div  class="item" v-if="mapData.type==1||mapData.type==3"><img style=" width: 32px;" src="../../../../assets/vehMonitor/siji.png" ><span>司机</span></div> -->
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import { direction, dateFormatUtil } from '@/utils/util'
import AMap from 'AMap'
import { vhcHisList, driverLastHis, realTimeTrajectory } from '@/api/vehMonitor'
export default {
  name: 'mapReal',
  props: {
    mapData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      dateFormatUtil: dateFormatUtil,
      isDetail: false,
      isVeh: true,
      isDri: false,
      activeName: 'gps',
      timer: null,
      map: null,
      markers: [],
      vehGps: null,
      allGps: [],
      driInfo: '',
      driving: null,
      jht: [],
      siJiAddressGrid: '',
      siJiDirverId: '',
      vhoFlag: false,
      siJiFlag: false
    }
  },
  mounted () {
    this.initMap()
    // 路线规划
    if (this.mapData.deliverLatitude && this.mapData.deliverLongitude && this.mapData.receivingLatitude && this.mapData.receivingLongitude) {
      let that = this
      AMap.plugin('AMap.Driving', function () { })
      var drivingOption = {
        policy: 1,
        size: 4,
        // panel: 'panel',
        map: this.map
      }
      console.log(this.mapData, 'this.mapData')
    }
    this.getGps()
    // this.getdriveData()
  },
  methods: {
    searchFn () {
      vhcHisList({ endTime: dateFormatUtil('yyyy-MM-dd hh:ii:ss', (new Date())), startTime: dateFormatUtil('yyyy-MM-dd hh:ii:ss', this.mapData.outTime), vchNo: this.mapData.vhcNo, serverName: '中物货运互联智慧物流平台' }).then(res => {
        if (res) {
          this.lineArr = res.list
          if (this.lineArr.length > 0) {
            this.polylineFn()
            this.isDetail = true
          }
          if (this.lineArr.length > 0) {
            this.marker.moveAlong(this.lineArr, 800)
          }
        }
      })
    },

    polylineFn () {
      this.marker = new AMap.Marker({
        map: this.map,
        position: this.lineArr[0],
        icon: 'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/vgs/monitor/cat.png',
        offset: new AMap.Pixel(-26, -13),
        autoRotation: true,
        cellValue: -90
      })
      // 绘制轨迹
      this.polyline = new AMap.Polyline({
        map: this.map,
        path: this.lineArr,
        showDir: true,
        strokeColor: '#28F', // 线颜色
        // strokeOpacity: 1,     //线透明度
        strokeWeight: 6 // 线宽
        // strokeStyle: "solid"  //线样式
      })

      var passedPolyline = new AMap.Polyline({
        map: this.map,
        // path: lineArr,
        strokeColor: '#AF5', // 线颜色
        // strokeOpacity: 1,     //线透明度
        strokeWeight: 6 // 线宽
        // strokeStyle: "solid"  //线样式
      })
      this.marker.on('moving', function (e) {
        passedPolyline.setPath(e.passedPath)
      })
      this.marker.on('click', this.showInfoM)
      this.map.setFitView()
    },
    getGps () {
      this.allGps = []
      let licensePlateColor = this.mapData.licensePlateColor == 7 ? 3 : this.mapData.licensePlateColor
      realTimeTrajectory({ plateNumber: this.mapData.plateNumber, licensePlateColor: licensePlateColor }).then(res => {
        if (res) {
          this.vehGps = res
          if (this.vehGps.direction) {
            this.vehGps.fx = direction(this.vehGps.direction)
          }
          this.allGps.push(this.vehGps)
          this.markerFn(this.allGps)
        } else {
          this.$alert('该车辆的实时位置无法查到', '系统提示')
        }
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    getdriveData () {
      driverLastHis({ driverId: this.mapData.dirverId }).then(res => {
        if (res) {
          this.driverData = res
          res.longitude = res.encryptLongitude
          res.latitude = res.encryptDimension
          this.siJiAddressGrid = res.addressGrid
          this.siJiDirverId = res.driverId
          res.plain = this.mapData.dirverName
          this.allGps.push(res)
        }
        this.markerFn(this.allGps)
      })
    },
    initMap () {
      this.map = new AMap.Map('map', {
        center: [116.397428, 39.90923], // [纬度，经度]
        resizeEnable: true,
        zoom: 12
      })
      this.map.setFitView()
    },
    markerFn (res) {
      // console.log(res,'ppp')
      this.map.clearMap()
      this.map.remove(this.markers)
      for (var i = 0; i < res.length; i += 1) {
        var marker
        let icon
        // console.log(res[i],'kkk')
        if (!res[i].driverId) {
          console.log('走到车辆')
          if (res[i].status == '行驶中') {
            icon = new AMap.Icon({
              image: 'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/vgs/monitor/travel' + res[i].fx + '.png',
              size: new AMap.Size(36, 36)
            })
          } else {
            icon = new AMap.Icon({
              image: 'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/vgs/monitor/parking' + res[i].fx + '.png',
              size: new AMap.Size(36, 36)
            })
          }
        } else {
          icon = new AMap.Icon({
            image: 'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/vgs/monitor/siji.png',
            size: new AMap.Size(36, 36)
          })
        }
        if (!res[i].status) {
          // console.log('走到司机')
          let position = [res[i].longitude, res[i].latitude]
          // console.log(position,'position')
          marker = new AMap.Marker({
            icon: icon,
            position: position,
            offset: new AMap.Pixel(0, 0),
            zIndex: 101,
            title: res[i].plain,
            map: this.map
          })
          marker.on('click', this.showInfoM1)
          this.markers.push(marker)
          this.map.setFitView()
        } else if (res[i].status) {
          // console.log('走到车辆')
          let position = [res[i].longitude, res[i].latitude]
          marker = new AMap.Marker({
            icon: icon,
            position: position,
            offset: new AMap.Pixel(0, 0),
            zIndex: 101,
            title: res[i].plain,
            map: this.map
          })
          marker.on('click', this.showInfoM)
          this.markers.push(marker)
          this.map.setFitView()
        }
      }
    },
    closeFn () {
      this.isDetail = false
    },
    showInfoM (e) {
      // console.log(e,'点击e')
      this.vehNo = e.target.w.title
      this.isDetail = true
      this.vhoFlag = true
      this.siJiFlag = false
      this.activeName = 'gps'
    },
    showInfoM1 (e) {
      this.isDetail = true
      this.isveh = false
      this.activeName = 'siji'
      this.vhoFlag = false
      this.siJiFlag = true
    },
    drawRoute (route) {
      var path = parseRouteToPath(route)
      var routeLine = new AMap.Polyline({
        path: path,
        isOutline: false,
        outlineColor: '#ffeeee',
        borderWeight: 2,
        strokeWeight: 5,
        strokeColor: '#0091ff',
        lineJoin: 'round'
      })
      routeLine.setMap(this.map)
      // 调整视野达到最佳显示区域
      this.map.setFitView()
      function parseRouteToPath (route) {
        var path = []
        for (var i = 0, l = route.steps.length; i < l; i++) {
          var step = route.steps[i]
          for (var j = 0, n = step.path.length; j < n; j++) {
            path.push(step.path[j])
          }
        }
        return path
      }
    }
  },
  destroyed () {
    clearInterval(this.timer)
  }
}
</script>

<style scoped lang='less'>
.zujian{
  height: calc(100vh - 40px);
}
.map{
  width: 100%;
  height: 100%;
  position: relative;
}
.tuli{
  position: absolute;
  right: 0px;
  bottom: 0;
  background: #fff;
  z-index: 999999;
  border-radius: 10px 0px 0px 0px;
  padding: 10px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.9);
  .box2{
    display: flex;
    .item{
      display: flex;
      width: 60px;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      img{
        margin-bottom: 6px;

      }
    }
  }
  .hr{
    height: 26px;
    width: 0px;
    border-left:1px solid #ddd!important;
  }
}
.detail{
  position: absolute;
  right: 0px;
  top: 0;
  background: #fff;
  width: 400px;
  border-radius: 0px 0px 0px 10px;
  box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.9);
  .box1{
    display: flex;
    flex-wrap: wrap;
    .item{
      width: 45%;
      margin-right: 10px;
      padding:4px 0 ;
      display: flex;
    }
    .name{
      color:  #0c46a2;
      flex-shrink:0;
    }
    .item1{
      width: 100%;
    }
  }
  /deep/.el-tabs__item{
    font-size: 12px;
  }
  /deep/.el-tabs__nav{
    padding-left: 10px;
  }
  /deep/.el-tab-pane{
    padding: 0px 10px 15px;
    font-size: 12px;
  }
  /deep/.el-tabs__active-bar{
    left: 10px;
  }
  .close{
    height: 40px;
    position:absolute;
    top:0;
    right: 20px;
    display: flex;
    align-items: center;
  }
}
/deep/.el-main{
  padding-top:0 !important;
}
.cont{
  display: flex;
   height: calc(100% + 12px);
   margin-top: -12px;
}
.left{
  width: 200px;
  height: 100%;
  overflow: auto;
  flex-shrink: 0;
}
.right{
  flex: 1;
  height: 100%;
}
.tbale{
  height: 30%;
  font-size: 12px;
}
#map{
  width: 100%;
  height: 100%;
}
/deep/.el-tree-node__label{
  font-size: 12px;
}
</style>
